<template>
    <Card :dis-hover="true">
        <Tabs v-model="store"
            :animated="false"
            :capture-focus="true">
            <TabPane label="现售仓库"
                name="curSaleSotre">
                <CurSaleWarehouseStore v-if="store === 'curSaleSotre'"
                    ref="curSaleWarehouseStore" />
            </TabPane>
            <TabPane label="预售仓库"
                name="preSaleSotre">
                <PreSaleWarehouseStore v-if="store === 'preSaleSotre'"
                    ref="preSaleWarehouseStore" />
            </TabPane>

            <TabPane label="自用仓库"
                name="selfStore">
                <SelfWarehouseStore v-if="store==='selfStore'"
                    ref="selfWarehouseStore" />
            </TabPane>

            <TabPane label="备用仓库"
                name="forwardStore">
                <ForwardWarehouseStore v-if="store==='forwardStore'"
                    ref="forwardWarehouseStore" />
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
import PreSaleWarehouseStore from '../preSale-warehouse-store/preSale-warehouse-store';
import CurSaleWarehouseStore from '../curSale-warehouse-store/curSale-warehouse-store';
import SelfWarehouseStore from '../self-warehouse-store/self-warehouse-store';
import ForwardWarehouseStore from '../forward-warehouse-store/forward-warehouse-store';

export default {
    name: 'warehouseStore',
    components: {
        PreSaleWarehouseStore,
        CurSaleWarehouseStore,
        SelfWarehouseStore,
        ForwardWarehouseStore
    },
    data() {
        return {
            store: "curSaleSotre"
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>
